/* Colouring-studio fixes.

   Kept out of coloring.js so the original stays reviewable and this can be
   deleted to revert. Loads between coloring.js and theme.js and replaces
   ImageStudio - the canvas flood-fill studio used by the homepage hero and
   the custom-story product page. Everything else in coloring.js is untouched.

   Two bugs, both found by tapping at it rather than reading it:

   1. GREEN TURNED INTO A WALL.
      The old test for "is this pixel a printed line" was
          d[i] + d[i+1] + d[i+2] < 300
      i.e. dark enough to be ink. Green is #3E9B4F = 62 + 155 + 79 = 296.
      So the instant a shape was filled green it became indistinguishable
      from line art: you could not recolour it, and no fill could cross it.
      Green was the ONLY crayon under the threshold - red 345, blue 353,
      purple 384, orange 429 - which is why it presented as a green-only bug.

      Ink is now identified the way ink actually differs from crayon: it is
      dark AND unsaturated.
          max(r,g,b) < 140  &&  max - min < 40
      Line art #17150F -> max 23, saturation 8  -> ink.
      Green #3E9B4F     -> max 155              -> not ink.
      Blue #2563D9      -> max 217              -> not ink.
      A grey anti-aliased edge (128,128,128) still reads as ink, so fills
      keep respecting the outlines.

   2. "START OVER" DID NOTHING.
      It called draw(), and draw() only repaints when the world changes:
          if(theme !== curTheme){ ... show(theme); }
      Choosing the same world again is a no-op, so the colouring survived.
      There is a real reset() now, wired to the .reset button inside the
      same .studio block.

      draw() still deliberately does NOT repaint, because it also fires on
      every keystroke in the name field - repainting there would wipe a
      child's colouring while a parent types their name. */

(function(){
  if (typeof ImageStudio !== 'function' || typeof CRAYONS === 'undefined') return;

  window.ImageStudio = function(sheetEl, crayonEl, sources){
    var cur = CRAYONS[0][1];
    if(crayonEl && !crayonEl.dataset.built){
      crayonEl.dataset.built = '1';
      CRAYONS.forEach(function(c,i){
        crayonEl.appendChild(crayonButton(c[0], c[1], i===0, function(hex){ cur = hex; }));
      });
    }

    sheetEl.classList.add('sheet--img');
    sheetEl.innerHTML = '<div class="img-banner"><span></span></div>' +
      '<canvas width="900" height="900" aria-label="Coloring page preview"></canvas>';
    var banner = sheetEl.querySelector('.img-banner span');
    var canvas = sheetEl.querySelector('canvas');
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    var W = 900, H = 900;
    var cache = {}, curTheme = null, pixels = null;

    function hexToRgb(h){
      return [parseInt(h.slice(1,3),16), parseInt(h.slice(3,5),16), parseInt(h.slice(5,7),16)];
    }

    function paint(img){
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0,0,W,H);
      ctx.drawImage(img, 0, 0, W, H);
      pixels = null;
    }

    function show(theme, done){
      if(cache[theme]){ paint(cache[theme]); if(done) done(); return; }
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function(){ cache[theme] = img; paint(img); if(done) done(); };
      img.src = sources[theme];
    }

    function fill(sx, sy, rgb){
      if(!pixels){
        try { pixels = ctx.getImageData(0,0,W,H); }
        catch(e){ return; }  /* canvas tainted - colouring off, preview still shows */
      }
      var d = pixels.data;

      /* dark AND unsaturated == printed line. See note 1 at the top. */
      function isInk(i){
        var r = d[i], g = d[i+1], b = d[i+2];
        var mx = r > g ? (r > b ? r : b) : (g > b ? g : b);
        var mn = r < g ? (r < b ? r : b) : (g < b ? g : b);
        return mx < 140 && (mx - mn) < 40;
      }

      var i0 = (sy*W+sx)*4;
      if(isInk(i0)) return;                                   // tapped a line, not a gap
      var sr = d[i0], sg = d[i0+1], sb = d[i0+2];
      if(Math.abs(sr-rgb[0]) + Math.abs(sg-rgb[1]) + Math.abs(sb-rgb[2]) < 12) return; // already this colour

      function match(px){
        var i = px*4;
        if(isInk(i)) return false;
        return Math.abs(d[i]-sr) + Math.abs(d[i+1]-sg) + Math.abs(d[i+2]-sb) < 150;
      }

      var seen = new Uint8Array(W*H);
      var stack = [sx, sy];

      while(stack.length){
        var y = stack.pop(), x = stack.pop();
        var px = y*W+x;
        if(seen[px] || !match(px)) continue;

        var xl = x; while(xl > 0   && !seen[y*W+xl-1] && match(y*W+xl-1)) xl--;
        var xr = x; while(xr < W-1 && !seen[y*W+xr+1] && match(y*W+xr+1)) xr++;

        for(var xi = xl; xi <= xr; xi++){
          var q = y*W+xi, i = q*4;
          seen[q] = 1;
          d[i] = rgb[0]; d[i+1] = rgb[1]; d[i+2] = rgb[2]; d[i+3] = 255;
        }

        if(y > 0)   seedRow(xl, xr, y-1, seen, match, stack);
        if(y < H-1) seedRow(xl, xr, y+1, seen, match, stack);
      }

      ctx.putImageData(pixels, 0, 0);
    }

    function seedRow(xl, xr, y, seen, match, stack){
      var run = false;
      for(var x = xl; x <= xr; x++){
        var px = y*W+x;
        var okHere = !seen[px] && match(px);
        if(okHere && !run){ stack.push(x, y); run = true; }
        else if(!okHere){ run = false; }
      }
    }

    function tap(clientX, clientY){
      var r = canvas.getBoundingClientRect();
      var x = Math.floor((clientX - r.left) / r.width  * W);
      var y = Math.floor((clientY - r.top)  / r.height * H);
      if(x < 0 || y < 0 || x >= W || y >= H) return;
      fill(x, y, hexToRgb(cur));
    }

    canvas.addEventListener('click', function(e){ tap(e.clientX, e.clientY); });

    function reset(){
      if(!curTheme) return;
      if(cache[curTheme]) paint(cache[curTheme]);
      else show(curTheme);
    }

    /* Wire the "Start over" button that sits in the same .studio block.
       theme.js also binds drawHome() to it, which is harmless - that only
       refreshes the banner text. */
    var host = sheetEl.closest ? sheetEl.closest('.studio') : null;
    var rb = host ? host.querySelector('.reset') : null;
    if(rb && !rb.dataset.slReset){
      rb.dataset.slReset = '1';
      rb.addEventListener('click', function(){ reset(); });
    }

    return {
      draw: function(name, theme){
        if(!sources[theme]) theme = 'dragon';
        banner.textContent = (name
          ? possessive(name) + SCENES[theme].title
          : SCENES[theme].label).toUpperCase();
        if(theme !== curTheme){ curTheme = theme; show(theme); }
      },
      reset: reset
    };
  };
})();
